const ROTATION_MS = 3000;

function initRebelaNotice(bar) {
  const messages = Array.from(bar.querySelectorAll('[data-rh-notice-message]'));
  const count = bar.querySelector('[data-rh-notice-count]');
  const toggle = bar.querySelector('[data-rh-notice-toggle]');
  if (!messages.length || !count || !toggle) return;

  let index = 0;
  let paused = false;
  let elapsedBeforePause = 0;
  let startedAt = performance.now();
  let frame = 0;

  const render = () => {
    messages.forEach((message, messageIndex) => {
      const active = messageIndex === index;
      message.classList.toggle('is-active', active);
      message.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) message.removeAttribute('tabindex');
      else message.setAttribute('tabindex', '-1');
    });
    count.textContent = `${index + 1}/${messages.length}`;
  };

  const setPausedState = () => {
    bar.classList.toggle('is-paused', paused);
    toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggle.setAttribute('aria-label', paused ? 'Resume announcements' : 'Pause announcements');
  };

  const tick = (now) => {
    if (paused) return;

    const elapsed = elapsedBeforePause + (now - startedAt);
    const progress = Math.min(elapsed / ROTATION_MS, 1);
    bar.style.setProperty('--rh-notice-progress', `${progress * 360}deg`);

    if (elapsed >= ROTATION_MS) {
      index = (index + 1) % messages.length;
      elapsedBeforePause = 0;
      startedAt = now;
      bar.style.setProperty('--rh-notice-progress', '0deg');
      render();
    }

    frame = requestAnimationFrame(tick);
  };

  toggle.addEventListener('click', () => {
    const now = performance.now();

    if (paused) {
      paused = false;
      startedAt = now;
      setPausedState();
      frame = requestAnimationFrame(tick);
      return;
    }

    elapsedBeforePause += now - startedAt;
    paused = true;
    cancelAnimationFrame(frame);
    setPausedState();
  });

  render();
  setPausedState();
  frame = requestAnimationFrame(tick);
}

document.querySelectorAll('[data-rh-notice]').forEach(initRebelaNotice);
